package com.nonopn.skywatcher.common.app.pages.map.model.weather

import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.alert_orange_explanation
import com.nonopn.skywatcher.common.app.res.alert_red_explanation
import com.nonopn.skywatcher.common.app.res.alert_yellow_explanation
import com.nonopn.skywatcher.design.theme.AppColor
import kotlinx.serialization.Serializable

@Serializable
enum class AlertType {
    NONE,
    KM50,
    KM30,
    KM10,
    ManualRed,
    ManualOrange,
    ManualYellow;

    fun toRestApi() = when (this) {
        AlertType.NONE -> ThunderDetectionManualAlertType.Yellow
        AlertType.KM50 -> ThunderDetectionManualAlertType.Yellow
        AlertType.KM30 -> ThunderDetectionManualAlertType.Orange
        AlertType.KM10 -> ThunderDetectionManualAlertType.Red
        AlertType.ManualRed -> ThunderDetectionManualAlertType.Red
        AlertType.ManualOrange -> ThunderDetectionManualAlertType.Orange
        AlertType.ManualYellow -> ThunderDetectionManualAlertType.Yellow
    }
}

fun AlertType?.appColor() = when (this) {
    AlertType.NONE -> AppColor.YellowDark
    AlertType.KM50 -> AppColor.YellowDark
    AlertType.KM30 -> AppColor.Orange
    AlertType.KM10 -> AppColor.RedHeavy
    AlertType.ManualRed -> AppColor.RedHeavy
    AlertType.ManualOrange -> AppColor.Orange
    AlertType.ManualYellow -> AppColor.YellowDark
    null -> AppColor.YellowDark
}

fun AlertType?.explanation() = when (this) {
    AlertType.NONE -> Res.string.alert_yellow_explanation
    AlertType.KM50 -> Res.string.alert_yellow_explanation
    AlertType.KM30 -> Res.string.alert_orange_explanation
    AlertType.KM10 -> Res.string.alert_red_explanation
    AlertType.ManualRed -> Res.string.alert_red_explanation
    AlertType.ManualOrange -> Res.string.alert_orange_explanation
    AlertType.ManualYellow -> Res.string.alert_yellow_explanation
    null -> Res.string.alert_yellow_explanation
}


@Serializable
enum class ThunderDetectionManualAlertType {
    Red,
    Orange,
    Yellow
}